import { isNonNullable } from "./typescript"

/**
 * Transforms a list of items into a map by associating each key with the corresponding value.
 */
export function createMap<Item, Key, Value = Item>(
  items: Item[],
  createKey: (item: Item) => Key,
  createValue: (item: Item) => Value = (item) => item as unknown as Value,
): Map<NonNullable<Key>, NonNullable<Value>> {
  return items.reduce((result, item) => {
    const key = createKey(item)
    const value = createValue ? createValue?.(item) : (item as unknown as Value)

    if (isNonNullable(key) && isNonNullable(value)) {
      result.set(key, value)
    }

    return result
  }, new Map<NonNullable<Key>, NonNullable<Value>>())
}

/**
 * Transforms a list of items into a map by associating each key with the corresponding value.
 */
export function groupBy<Item, Key, Value = Item>(
  items: Item[],
  createKey: (item: Item) => Key,
  createValue: (item: Item) => Value = (item) => item as unknown as Value,
) {
  return items.reduce((result, item) => {
    const key = createKey(item)
    const value = createValue?.(item) || (item as unknown as Value)

    if (result.has(key)) {
      result.get(key)?.push(value)
    } else {
      result.set(key, [value])
    }

    return result
  }, new Map<Key, Value[]>())
}
